import type { ProductTypes } from 'modules/products'

import CategoriesButtonMenuMultiplePromotions from './CategoriesButtonMenuMultiplePromotions'
import CategoriesButtonMenuSinglePromotion from './CategoriesButtonMenuSinglePromotion'

const CategoriesNavigationPromotions = ({
  menuPromotionItems
}: {
  menuPromotionItems: ProductTypes[]
}) => {
  switch (menuPromotionItems.length) {
    case 1:
      return (
        <CategoriesButtonMenuSinglePromotion
          promotedProduct={menuPromotionItems[0]}
        />
      )
    case 3:
      return (
        <CategoriesButtonMenuMultiplePromotions
          menuPromotionItems={menuPromotionItems}
        />
      )
    default:
      return null
  }
}

export default CategoriesNavigationPromotions
